// @ts-nocheck
import { IconOffset } from "@toolkit/Framework/Types/Icon";
import * as React from "react";

const CheckmarkCircle2Fill: React.FC = () => {
    return (
        <svg focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
            <path
                d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10 10-4.477 10-10S17.523 2 12 2zm4.3 7.61l-4.57 6a1 1 0 01-1.58.01l-2.44-3.11a1.001 1.001 0 011.58-1.23l1.63 2.08 3.78-5a1.006 1.006 0 111.6 1.22v.03z"
                fill="currentColor"
                fillRule="evenodd"
            />
        </svg>
    );
};

export const CheckmarkCircle2FillOffset: IconOffset = {
    vertical: 8,
    horizontal: 8,
};

export default React.memo(CheckmarkCircle2Fill);
